import {Option} from 'platform/components';

/**
 * One group of document-template options as `useDocumentTemplates` returns them. The hook groups
 * templates by authorization profile or by locale, so a choice fed with them receives groups
 * rather than a flat option list.
 */
export interface DocumentTemplateOptionGroup {
  label: string | undefined;
  options: Option[];
}
